import { calculateCheckDigit } from '../../../utils/order-utils';

export const orderNumberFormat = (
  orderNumber: string | undefined | null,
  transactionId?: number | undefined | null,
  registerNumber?: number | undefined | null,
  showTextLabel = true,
  customerType?: string,
) => {
  if (
    (!orderNumber || orderNumber === 'undefined') &&
    Boolean(transactionId) &&
    Boolean(registerNumber)
  ) {
    return `${showTextLabel ? 'Receipt ' : ''}# ${instoreOrderNumberFormat(
      registerNumber,
      transactionId,
      customerType,
    )}`;
  }
  if (orderNumber === null || orderNumber === undefined) {
    return 'Order Number Unavailable';
  }
  if (orderNumber?.includes('-')) {
    return `${showTextLabel ? 'Receipt ' : ''}# ${orderNumber}`;
  }
  return `${showTextLabel ? 'Order ' : ''}# ${orderNumber}`;
};

export const instoreOrderNumberFormat = (
  registerNumber: number | undefined | null,
  transactionId: number | undefined | null,
  customerType?: string,
) => {
  if (!registerNumber || !transactionId) {
    return '';
  }
  const registerNumberStr = registerNumber?.toString() || '';
  const transactionIdStr = transactionId?.toString() || '';

  const paddedRegisterNumber = registerNumberStr.padStart(5, '0');
  const paddedTransactionId = transactionIdStr.padStart(5, '0');

  if (customerType === 'b2c') {
    const transIdWithCheckDigit =
      transactionIdStr +
      calculateCheckDigit(registerNumberStr, transactionIdStr.padStart(4, '0'));

    return `${paddedRegisterNumber}-${transIdWithCheckDigit.padStart(5, '0')}`;
  }

  if (customerType === 'b2b' && transactionId?.toString()?.length < 5) {
    const transIdWithCheckDigit =
      transactionIdStr +
      calculateCheckDigit(registerNumberStr, transactionIdStr.padStart(4, '0'));

    return `${paddedRegisterNumber}-${transIdWithCheckDigit.padStart(5, '0')}`;
  }

  return `${paddedRegisterNumber}-${paddedTransactionId}`;
};

/**
 * Should have same logic as orderNumberFormat() above
 * Includes both CashNCarry and H Orders
 * @param orderNumber
 * @param transactionId field that is used for cashNCarry and some H order types
 * @param registerNumber field that is used for cashNCarry and some H order types
 * @returns true if the order number is in the store format and therefore should be treated as a receipt number
 */
export const isInStoreOrderNumber = (
  orderNumber: string | undefined | null,
  transactionId?: number | undefined | null,
  registerNumber?: number | undefined | null,
) => {
  if (
    (!orderNumber || orderNumber === 'undefined') &&
    Boolean(transactionId) &&
    Boolean(registerNumber)
  ) {
    return true;
  }
  if (orderNumber === null || orderNumber === undefined) {
    return false;
  }
  if (orderNumber?.includes('-')) {
    return true;
  }
  return false;
};

/**
 * Determines if the order is a CashNCarry order based on if order number starts with a number and order origin is not online
 * @param orderNumber
 * @param orderOrigin OMS field that indicates where the order originated from, can be either online or store number
 * @returns true if the order is a CashNCarry order, false otherwise
 */
export const isCashNCarryOrder = (
  orderNumber: string | undefined,
  orderOrigin?: string,
  registerNumber?: number,
  transactionId?: number,
) => {
  let parsedOrderNumber = orderNumber;
  if (!parsedOrderNumber || parsedOrderNumber === 'undefined') {
    parsedOrderNumber = instoreOrderNumberFormat(registerNumber, transactionId);
  }
  const firstCharIsNumber = /^[0-9]/.test(parsedOrderNumber);
  const containsHyphen = parsedOrderNumber.includes('-');
  return firstCharIsNumber && containsHyphen && orderOrigin !== 'online';
};
